import { Badge, Group, Text } from "@mantine/core";
import { useSnapshot } from "valtio";
import { assistantLogTexts } from "@/locales/assistant-log";
import { assistantLogDetailTexts } from "@/locales/assistant-log-detail";
import { assistantUsageLogTexts } from "@/locales/assistant-usage-log";
import { i18nStore } from "@/store/i18n";
import type { AssistantLogModelUseDto } from "@/types/ai-assistant-log";
import { VENDOR_COLOR, vendorLabel } from "./usage-log.logic";

/**
 * Lencana vendor + nama model, dipakai di ketiga lapis "Log Percakapan".
 * Warna diambil dari `VENDOR_COLOR` yang sama dengan tabel log penyedia
 * (ungu Claude / tosca ChatGPT) supaya tidak pernah berbeda antar halaman.
 */
export function LogVendorBadge({
	use,
	showTurns = false,
}: {
	use: AssistantLogModelUseDto;
	/** Tampilkan "N giliran" di sebelah nama model (panel info lapis 3). */
	showTurns?: boolean;
}) {
	const { lang: uiLang } = useSnapshot(i18nStore);
	const lang = uiLang === "en" ? "en" : "id";
	const t = assistantLogTexts[lang];
	const vendorText = assistantUsageLogTexts[lang];
	const detailText = assistantLogDetailTexts[lang];

	return (
		<Group gap="xs" wrap="nowrap">
			<Badge color={VENDOR_COLOR[use.vendor]} variant="light" size="sm">
				{vendorLabel(use.vendor, vendorText)}
			</Badge>
			<Text size="sm" ff="monospace" lineClamp={1}>
				{use.model ?? t.modelUnknown}
			</Text>
			{showTurns && (
				<Text size="xs" c="dimmed">
					{detailText.turns(String(use.turns))}
				</Text>
			)}
		</Group>
	);
}
